import { FC, useEffect, useState } from "react";
import CustomizedInput from "../CreateForm/InputBase";
import CustomizedSingleSelectDropdown from "../CreateForm/DropdownBase";
import './style.scss'
import { FontTitleSectionContainer } from "../CustomCss/styled";
import { useMediaQuery } from "@mui/material";
import { StandardScreenHeightModeSelect, StandardScreenWidthTypeSelect } from "../constant/constant";

const initial = {
  mode: "standard-screen",
  width: "100",
  widthUnit: "%",
  heightMode: "auto",
  height: "auto",
  heightUnit: "%"
};

interface StandardScreenComponentProps {
  setWidgetConfigDetails: any;
  widgetConfigDetails?: any;
}

const StandardScreenComponent: FC<StandardScreenComponentProps> = ({ setWidgetConfigDetails, widgetConfigDetails }) => {
  const [embedData, setEmbedData] = useState(initial);
  const isLessThan1440 = useMediaQuery("(max-width:1439px)");

  useEffect(() => {
    setWidgetConfigDetails((prev: any) => {
      return {
        ...prev,
        height: `${embedData?.heightMode === "fixed" ? embedData?.height + embedData?.heightUnit : "auto"}`,
        width: embedData?.width + embedData?.widthUnit
      }
    })

  }, [embedData])

  useEffect(() => {
    if (widgetConfigDetails?.mode === "standard-screen" && widgetConfigDetails?.height !== undefined && widgetConfigDetails?.width !== undefined) {
      setEmbedData((prev: any) => ({
        ...prev,
        height: widgetConfigDetails?.height === "auto" ? "auto" : widgetConfigDetails?.height?.replace(/[^0-9]/g, ""),
        heightMode: widgetConfigDetails?.height === "auto" ? "auto" : "fixed",
        heightUnit: widgetConfigDetails?.height === "auto" ? "%" : widgetConfigDetails?.height?.replace(/[0-9]/g, ""),
        width: widgetConfigDetails?.width?.replace(/[^0-9]/g, ""),
        widthUnit: widgetConfigDetails?.width?.replace(/[0-9]/g, ""

        )
      }))
    }
  }, [widgetConfigDetails.id])

  return (
    <div className="standardScreen">
      <FontTitleSectionContainer isLargeScreen={!isLessThan1440}>
        Width
      </FontTitleSectionContainer>
      <div className="widthStandardEmbedMode">
        <CustomizedInput
          placeholder=""
          style={{ width: 130 }}
          value={embedData.width}
          onChange={(e: any) => setEmbedData((prev) => ({ ...prev, width: e.target.value }))}
          type="number"
        />
        <CustomizedSingleSelectDropdown
          value={embedData.widthUnit}
          setValue={(e: any) => setEmbedData((prev) => ({ ...prev, widthUnit: e }))}
          dataProvider={StandardScreenWidthTypeSelect}
        />
      </div>
      <div className="standardScreenHeight">
        <FontTitleSectionContainer isLargeScreen={!isLessThan1440}>
          Height
        </FontTitleSectionContainer>
        <CustomizedSingleSelectDropdown
          value={embedData.heightMode}
          setValue={(e: any) => setEmbedData((prev) => ({ ...prev, heightMode: e, height: e === "fixed" ? "100" : prev.height }))}
          dataProvider={StandardScreenHeightModeSelect}
        />
      </div>
      {embedData.heightMode === "fixed" && (
        <div className="heightStandardEmbedMode">
          <CustomizedInput
            placeholder=""
            style={{ width: 130 }}
            value={embedData.height}
            onChange={(e: any) => setEmbedData((prev) => ({ ...prev, height: e.target.value }))}
            type="number"
          />
          <CustomizedSingleSelectDropdown
            value={embedData.heightUnit}
            setValue={(e: any) => setEmbedData((prev) => ({ ...prev, heightUnit: e }))}
            dataProvider={StandardScreenWidthTypeSelect}
          />
        </div>
      )}
    </div>
  );
};

export default StandardScreenComponent;